import { render, staticRenderFns } from "./ProjectDraftListPage.vue?vue&type=template&id=512a0a86"
import script from "./ProjectDraftListPage.vue?vue&type=script&lang=ts"
export * from "./ProjectDraftListPage.vue?vue&type=script&lang=ts"
import style0 from "./ProjectDraftListPage.vue?vue&type=style&index=0&id=512a0a86&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports